import { get } from 'lodash'
import store from '../redux/store'

export default (source = '', fileType = '', data = {}) => {
    const { auth = {} } = store.getState()
    const headers = {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        'Access-Control-Allow-Origin': true,
    }

    if (source === 'upload') {
        delete headers['Accept']
        delete headers['Access-Control-Allow-Origin']
        headers['Content-Type'] = fileType
    }

    if (
        auth?.access_token &&
        source !== 'upload' &&
        //dont add Authorization on header if refreshing token
        !get(data, 'refreshToken', '')
    ) {
        headers.Authorization = `Bearer ${auth?.access_token}`
    }

    return headers
}
